import { type SelectDataObject } from '../_tools/inputfields/Select';

export const kraftstoffPreisStand = new Date('2024-06-27');

const sIntKraftstoff: SelectDataObject<{ e: string; p?: number }>[] = [
    { i: 0, t: '(unbekannt)', e: 'l/100km' },
    { i: 1, t: 'Benzin', e: 'l/100km', hidden: true },
    { i: 2, t: 'Diesel', e: 'l/100km', p: 1.724 },
    { i: 3, t: 'Gas', e: 'kg/100km' },
    { i: 10, t: 'Normalbenzin', e: 'l/100km', hidden: true },
    { i: 13, t: 'Super E10', e: 'l/100km', p: 1.794 },
    { i: 11, t: 'Super', e: 'l/100km', p: 1.85 },
    { i: 12, t: 'Super Plus', e: 'l/100km', p: 2.077 },
    { i: 14, t: 'Ethanolkraftstoff (E85)', e: 'l/100km' },
    { i: 15, t: 'Flüssiggas (LPG)', e: 'kg/100km', p: 1.066 },
    { i: 16, t: 'Erdgas H (CNG)', e: 'kg/100km', p: 1.423 },
    { i: 17, t: 'Erdgas L (LNG)', e: 'kg/100km', p: 1.241 },
    { i: 18, t: 'Strom', e: 'kWh/100km', p: 0.375 },
    { i: 19, t: 'Wasserstoff', e: 'kg/100km', p: 15.54 },
];
export default sIntKraftstoff;
